// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import TextField from 'material-ui/TextField';

import TitledCard from 'common/components/cards/TitledCard';
import { Label } from '../styles';
import type { RadioInformationFormSection, TechnologyDirectorData } from '../../domain/RadioInformationForm';

type Props = {
  onChange: (value: RadioInformationFormSection) => void,
  data: TechnologyDirectorData,
  t: any,
}

function TechnologyDirector(props: Props) {
  return (
    <TitledCard title={props.t('technologyDirector')}>
      <div className="row">
        <div className="col-xs-8">
          <Label>{props.t('name')}</Label>
          <TextField
            name="name"
            onChange={(e, v) => props.onChange({ ...props.data, name: v })}
            value={props.data.name}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('phone')}</Label>
          <TextField
            name="phone"
            onChange={(e, v) => props.onChange({ ...props.data, phone: v })}
            value={props.data.phone}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('email')}</Label>
          <TextField
            name="email"
            onChange={(e, v) => props.onChange({ ...props.data, email: v })}
            value={props.data.email}
            fullWidth
          />
        </div>
      </div>
    </TitledCard>
  );
}

export default translate('radioConfiguration')(TechnologyDirector);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/radioInformationForm/TechnologyDirector.js